export { default } from './ProductAside';
